import { useEffect, useMemo, useState } from 'react';
import TimerIcon from '../../assets/images/landing/sleep/timer-icon.svg';

const RESET_HOUR = 6;
const TICK_MS = 10;

type CountdownParts = {
  hours: number;
  minutes: number;
  seconds: number;
  microseconds: number;
};

function getNextResetAtSix(nowMs: number) {
  const now = new Date(nowMs);
  const next = new Date(now);
  next.setHours(RESET_HOUR, 0, 0, 0);

  if (nowMs >= next.getTime()) {
    next.setDate(next.getDate() + 1);
  }

  return next.getTime();
}

function getCountdownParts(nowMs: number): CountdownParts {
  const nextResetMs = getNextResetAtSix(nowMs);
  const remainingMs = Math.max(nextResetMs - nowMs, 0);

  const hours = Math.floor(remainingMs / (1000 * 60 * 60));
  const minutes = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remainingMs % (1000 * 60)) / 1000);
  const microseconds = Math.floor((remainingMs % 1000) / 10);

  return { hours, minutes, seconds, microseconds };
}

function pad2(value: number) {
  return value.toString().padStart(2, '0');
}

export default function ResetAtSixCountdown({ className = '' }: { className?: string }) {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    const timer = window.setInterval(() => {
      setNowMs(Date.now());
    }, TICK_MS);

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  const { hours, minutes, seconds, microseconds } = useMemo(() => getCountdownParts(nowMs), [nowMs]);
  const timeText = `${pad2(hours)}:${pad2(minutes)}:${pad2(seconds)}:${pad2(microseconds)}`;

  return (
    <div
      className={`mx-auto flex h-[clamp(82px,14vw,156px)] w-full max-w-[800px] items-center justify-center gap-[clamp(8px,2vw,20px)] rounded-[20px] bg-[#191F28] px-[clamp(12px,2.4vw,30px)] ${className}`.trim()}
    >
      <img src={TimerIcon} alt="" aria-hidden="true" className="h-[clamp(30px,6vw,58px)] w-[clamp(30px,6vw,58px)] shrink-0" />
      <p
        className="text-center w-[11ch] whitespace-nowrap text-left font-['Pretendard'] tabular-nums text-[clamp(34px,7.2vw,88px)] font-semibold leading-none tracking-[-0.03em] text-[#F2F4F6]"
        style={{ fontVariantNumeric: 'tabular-nums lining-nums', fontFeatureSettings: '"tnum" 1, "lnum" 1' }}
      >
        {timeText}
      </p>
    </div>
  );
}
